import { SET_ENGAGE, SET_LOADING, SET_ERROR } from '@/store/mutation-types'

export default {
	/**
	 * Set the engage properties.
	 *
	 * @param {Object} state
	 * @param {Object} engageProperties
	 * @return {void}
	 */
	[SET_ENGAGE](state, engageProperties) {
		state.engageProperties = {
			...state.engageProperties,
			...engageProperties,
		}
		state.error = false
	},

	/**
	 * Set the loading state.
	 *
	 * @param {Object} state
	 * @param {Boolean} loading
	 * @return {void}
	 */
	[SET_LOADING](state, loading) {
		state.loading = loading
	},

	/**
	 * Set the error state.
	 *
	 * @param {Object} state
	 * @param {Boolean} error
	 * @return {void}
	 */
	[SET_ERROR](state, error) {
		state.error = error
	},
}
